import API from '@/lib/API.js'
import comun from './comun.js'
const seccionales = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getSeccionales();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Seccionales.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.id_seccional == payload)
            commit("select", sec)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_seccional: 0,
                Descripcion_seccional: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_seccional != 0) {
                data = await API.Seccionales.modificar(state.Seleccionado);
                str += "Seccional modificada"
            } else {
                data = await API.Seccionales.alta(state.Seleccionado);
                str += `Nueva seccional de alta'${data.Descripcion_seccional}'`
            }
            let secs = await API.Seccionales.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_seccional)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_seccional != 0) {
                data = await API.Seccionales.modificar(entidad);
                str += "Seccional modificada"
            } else {
                data = await API.Seccionales.alta(entidad);
                str += `Nueva seccional de alta'${data.Descripcion_seccional}'`
            }
            let secs = await API.Seccionales.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_seccional)
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Seccionales.eliminar(id);
                str += "Seccional eliminada"
            }
            let ents = await API.Seccionales.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        getSeccionales: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default seccionales;